var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion-item" }, [
    _c(
      "div",
      { staticClass: "accordion-header" },
      [
        _c(
          "div",
          {
            staticClass: "main-section",
            on: {
              click: function($event) {
                _vm.open = !_vm.open
              }
            }
          },
          [
            _c("span", { staticClass: "header-label" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]
        ),
        _vm._v(" "),
        _vm._t("accordionTitleExtraContent")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "accordion-body",
        class: { "accordion-body-active": _vm.open }
      },
      [_vm._t("accordionBodyContent")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18ce8353", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18ce8353","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/HomeAccordion.vue
// module id = null
// module chunks = 